<template>
<div class="chapter">
<div class="inner_page">
<p class="ChapNumber2"><a id="page_vi"></a><a id="toc"></a>C<span class="small">ONTENTS</span></p>
<table border="0" cellpadding="0" cellspacing="0">
<tbody><tr>
<td class="tdr2"> </td>
<td class="tdl1a"> </td>
<td class="tdl1"><a href="#/html/9780292734746_07_ack">Acknowledgments</a></td>
</tr>
<tr>
<td class="tdr1"><a href="#/html/9780292734746_09_int">I<span class="small">NTRODUCTION</span></a></td>
<td class="tdl1a"> </td>
<td class="tdl1"><a href="#/html/9780292734746_09_int">Afterthoughts on His Afterlives</a></td></tr>
<tr>
<td class="tdr1"><a href="#/html/9780292734746_10_pt01">P<span class="small">ART</span> O<span class="small">NE</span></a></td>
<td class="tdl1a"> </td>
<td class="tdl1"><a href="#/html/9780292734746_10_pt01"><strong><em>If the Mantle Fits</em> . . .</strong></a></td>
</tr>
<tr>
<td class="tdr"><a href="#/html/9780292734746_11_cha01">C<span class="small">HAPTER</span> 1</a></td>
<td class="tdl1a"> </td>
<td class="tdl"><a href="#/html/9780292734746_11_cha01">Virtuous Men? or “The American Orwell” (I)</a></td>
</tr>
<tr>
<td class="tdr"><a href="#/html/9780292734746_12_cha02">C<span class="small">HAPTER</span> 2</a></td>
<td class="tdl1a"> </td>
<td class="tdl"><a href="#/html/9780292734746_12_cha02">“Dear Dwight,” or “The American Orwell” (II)</a></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_13_cha03" title="Link target outside of Sample">C<span class="small">HAPTER</span> 3</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_13_cha03" title="Link target outside of Sample">“St. Irving”? or “The American Orwell” (III)</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_14_cha04" title="Link target outside of Sample">C<span class="small">HAPTER</span> 4</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_14_cha04" title="Link target outside of Sample">Fellow Contrarians? or “The (Anglo-)American Orwell” (IV)</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_15_cha05" title="Link target outside of Sample">C<span class="small">HAPTER</span> 5</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_15_cha05" title="Link target outside of Sample">“True Patriot and Traditionalist,” or “The (Hungarian-)American Orwell” (V)</span></td>
</tr>
<tr>
<td class="tdr1"><span href="#/html/9780292734746_16_pt02" title="Link target outside of Sample">P<span class="small">ART</span> T<span class="small">WO</span></span></td>
<td class="tdl1a"> </td>
<td class="tdl1"><span href="#/html/9780292734746_16_pt02" title="Link target outside of Sample"><strong><em>Politics and the German Language</em></strong></span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_17_cha06" title="Link target outside of Sample">C<span class="small">HAPTER</span> 6</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_17_cha06" title="Link target outside of Sample">The (Un-rosy) State of Orwellian Unlearning</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_18_cha07" title="Link target outside of Sample">C<span class="small">HAPTER</span> 7</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_18_cha07" title="Link target outside of Sample">Books That Led to Miniluv</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_19_cha08" title="Link target outside of Sample">C<span class="small">HAPTER</span> 8</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_19_cha08" title="Link target outside of Sample">2 + 2 = 5?</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_20_cha09" title="Link target outside of Sample">C<span class="small">HAPTER</span> 9</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_20_cha09" title="Link target outside of Sample">Behind the Wall, or How the Eurasian <em>Reich</em> Viewed Oceania</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_21_cha10" title="Link target outside of Sample">C<span class="small">HAPTER</span> 10</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_21_cha10" title="Link target outside of Sample">Revenge of the Thought Police</span></td>
</tr>
<tr>
<td class="tdr1"><span href="#/html/9780292734746_22_pt03" title="Link target outside of Sample">P<span class="small">ART</span> T<span class="small">HREE</span></span></td>
<td class="tdl1a"> </td>
<td class="tdl1"><span href="#/html/9780292734746_22_pt03" title="Link target outside of Sample"><strong><em>The Un</em>(<em>der</em>)<em>examined Orwell</em></strong></span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_23_cha11" title="Link target outside of Sample">C<span class="small">HAPTER</span> 11</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_23_cha11" title="Link target outside of Sample">Did Papa Rescue St. George?</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_24_cha12" title="Link target outside of Sample">C<span class="small">HAPTER</span> 12</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_24_cha12" title="Link target outside of Sample">Big Rock (Sugar)candy Mountain?</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_25_cha13" title="Link target outside of Sample">C<span class="small">HAPTER</span> 13</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_25_cha13" title="Link target outside of Sample">Literacy and the English Language</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_26_cha14" title="Link target outside of Sample">C<span class="small">HAPTER</span> 14</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_26_cha14" title="Link target outside of Sample">George Orwell, Literary Theorist?</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_27_cha15" title="Link target outside of Sample">C<span class="small">HAPTER</span> 15</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_27_cha15" title="Link target outside of Sample">The Architectonics of Room</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_28_cha16" title="Link target outside of Sample">C<span class="small">HAPTER</span> 16</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_28_cha16" title="Link target outside of Sample">The Review Orwell Never Wrote?</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_29_cha17" title="Link target outside of Sample">C<span class="small">HAPTER</span> 17</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_29_cha17" title="Link target outside of Sample">The Life Orwell Never Lived?</span></td>
</tr>
<tr>
<td class="tdr"><span href="#/html/9780292734746_30_cha18" title="Link target outside of Sample">C<span class="small">HAPTER</span> 18</span></td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_30_cha18" title="Link target outside of Sample">The Centenarian, Our Contemporary</span></td>
</tr>
<tr>
<td class="tdr1"><span href="#/html/9780292734746_31_con" title="Link target outside of Sample">C<span class="small">ONCLUSION</span></span></td>
<td class="tdl1a"> </td>
<td class="tdl1"><span href="#/html/9780292734746_31_con" title="Link target outside of Sample">If He Had Lived . . .</span></td>
</tr>
<tr>
<td class="tdr1"> </td>
<td class="tdl1a"> </td>
<td class="tdl1"><span href="#/html/9780292734746_32_not" title="Link target outside of Sample">Notes</span></td>
</tr>
<tr>
<td class="tdr"> </td>
<td class="tdl1a"> </td>
<td class="tdl"><span href="#/html/9780292734746_33_ind" title="Link target outside of Sample">Index</span></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292734746_06_toc.vue?181a7929